import { render, staticRenderFns } from "./ValentinesDay_defaultSection.vue?vue&type=template&id=a840847a&scoped=true"
import script from "./ValentinesDay_defaultSection.vue?vue&type=script&lang=ts"
export * from "./ValentinesDay_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./ValentinesDay_defaultSection.vue?vue&type=style&index=0&id=a840847a&prod&scoped=true&lang=css"
import style1 from "./ValentinesDay_defaultSection.vue?vue&type=style&index=1&id=a840847a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a840847a",
  null
  
)

export default component.exports